import './banner_home.css';
import Logo from './../../../../assets/logo/logo.svg';
import AppleIcon from './../../../../assets/icons/library/apple.png';
import PlayStore from './../../../../assets/icons/library/google-play.webp';
import WebIcon from './../../../../assets/icons/samples/web.svg';
import { WrapperComponent, StoreButton } from './../../../_imports';
import { useNavigate } from 'react-router-dom';
import Links from '../../../../constants/links';

function BannerHome() {
    const navigate = useNavigate();

    return (
        <section className="banner-home">
            <h1 className="visually-hidden">Tonalida - Conectando Empresas e Candidatos</h1>
            {/* Main Visuals (Hands) - Full Width */}
            <div className="banner-visuals">
                <div className="visual-left">
                    <img
                        src="/assets/banner_home_enterprise.png"
                        alt="Empresária buscando candidatos no tablet"
                        fetchPriority="high"
                        onClick={() => navigate('/empresa')}
                    />
                </div>
                <div className="visual-right">
                    <img
                        src="/assets/banner_home_candidate.png"
                        alt="Candidata buscando vagas no celular"
                        fetchPriority="high"
                        onClick={() => navigate('/candidato')}
                    />
                </div>
            </div>

            {/* Center Logo - Moved out of Wrapper to fix z-index */}
            <div className="logo-center">
                <img src={Logo} alt="Logo Tonalida Central" />
            </div>

            {/* Content Limited to 1440px via WrapperComponent */}
            <WrapperComponent >
                <div className="banner-content-grid">

                    {/* Enterprise Section (Left) */}
                    <div className="content-block left">
                        <div className="block-header">
                            <h2>ENCONTRE OS MELHORES CANDIDATOS!</h2>
                            <p>
                                O sistema de R&S que centraliza todos <br />
                                os meios de divulgação de vagas <br />
                                e entrega currículos com <br />
                                análise de IA!
                            </p>
                        </div>
                        <div className="block-footer">
                            <p className="download-subtitle">Baixe aqui:</p>
                            <div className="action-buttons">
                                <StoreButton
                                    icon={PlayStore}
                                    storeName="Google Play"
                                    textTop="Disponível na"
                                    url={Links.appEntPlay}
                                    ariaLabel="Baixar aplicativo Tonalida para Empresas na Google Play"
                                />
                                <StoreButton
                                    icon={WebIcon}
                                    storeName="Portal Web"
                                    textTop="Disponível no"
                                    url={Links.portal}
                                    ariaLabel="Acessar Portal Web Tonalida para Empresas"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Candidate Section (Right) */}
                    <div className="content-block right">
                        <div className="block-header">
                            <h2>ENCONTRE VAGAS<br />NA SUA REGIÃO!</h2>
                            <p>
                                Busque vagas em todo o Brasil,<br />
                                se candidate a quantas vagas quiser <br />
                                e acompanhe em tempo real
                            </p>
                        </div>
                        <div className="block-footer">
                            <p className="download-subtitle">Baixe aqui:</p>
                            <div className="action-buttons">
                                <StoreButton
                                    icon={PlayStore}
                                    storeName="Google Play"
                                    textTop="Disponível na"
                                    url={Links.appCandPlay}
                                    ariaLabel="Baixar aplicativo Tonalida para Candidatos na Google Play"
                                />
                                <StoreButton
                                    icon={AppleIcon}
                                    storeName="App Store"
                                    textTop="Disponível na"
                                    url={Links.appCandIos}
                                    ariaLabel="Baixar aplicativo Tonalida para Candidatos na App Store"
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </WrapperComponent>
        </section>
    );
};

export default BannerHome;
